import { useMemo } from "react";
import ChartCanvas from "components/ChartCanvas";
import customersService from "services/admin/customersService";
import { countriesService } from "services/countries.service";
import { formatNumber, toPercent, useDashboardQuery } from "../dashboard-utils";
import ChartCard from "./ChartCard";
import { barOptions } from "./chartOptions";

const TOP = 7;

/**
 * Страны в виде горизонтальных столбцов (топ-7 + «Другие»):
 * круговая диаграмма с десятком секторов не читается.
 */
const CustomerCityzenship = () => {
  const q = useDashboardQuery(["customer-citizenship"], async () => (await customersService.getCustomersCitizenship()).data);
  // Справочник стран — чтобы вместо «KAZ» показать «Казахстан»
  const countries = useDashboardQuery(["countries"], async () => (await countriesService.getAll()).data);

  const { chartData, options, empty } = useMemo(() => {
    const list = Array.isArray(countries.data) ? countries.data : countries.data?.data || [];
    const names = new Map(list.map((c) => [c.id, c.name]));
    const rows = (Array.isArray(q.data) ? q.data : [])
      .filter((r) => r?.citizenshipID && Number(r.total) > 0)
      .map((r) => ({ label: names.get(r.citizenshipID) || r.citizenshipID, total: Number(r.total) }))
      .sort((a, b) => b.total - a.total);

    const top = rows.slice(0, TOP);
    const rest = rows.slice(TOP).reduce((acc, r) => acc + r.total, 0);
    if (rest > 0) top.push({ label: "Другие", total: rest });

    const grandTotal = rows.reduce((acc, r) => acc + r.total, 0);
    return {
      empty: top.length === 0,
      options: barOptions((v) => `${formatNumber(v)} чел. (${toPercent(v, grandTotal)}%)`, { horizontal: true }),
      chartData: {
        labels: top.map((r) => r.label),
        datasets: [
          {
            label: "Клиенты",
            data: top.map((r) => r.total),
            backgroundColor: top.map((r) => (r.label === "Другие" ? "rgba(148, 163, 184, 0.5)" : "rgba(6, 182, 212, 0.45)")),
            borderRadius: 4,
            maxBarThickness: 24,
          },
        ],
      },
    };
  }, [q.data, countries.data]);

  return (
    <ChartCard
      title="Клиенты по странам"
      periodLabel="За всё время"
      loading={q.isLoading}
      error={q.error}
      onRetry={q.refetch}
      empty={empty}
      emptyText="Нет данных"
    >
      <ChartCanvas type="bar" data={chartData} options={options} height={280} />
    </ChartCard>
  );
};

export default CustomerCityzenship;
